<template>
  <div>
    <div class="cardLayoutWrapper">
      <div class="elem elem--span-1">
        <BasicTooltip label="Action en attente">
          <BasicIcon
            v-if="item?.avecAlerteActionAFaire"
            name="danger"
            :active="false"
          />
        </BasicTooltip>
      </div>
      <div
        class="elem elem--span-4 elem--clickable"
        @click="useRechercheFactureActions().displayFacture(item.code)"
      >
        <span>{{ item?.reference }}</span>
      </div>
      <div class="elem elem--span-5">{{ dateTimeToReadableDate(item?.dateEmission) }}</div>
      <div class="elem elem--span-5">{{ dateTimeToReadableDate(item?.dateReception) }}</div>
      <div class="elem elem--span-6 elem--nowrap">{{ item?.etablissementEmetteur?.denomination }}</div>
      <div class="elem elem--span-3 elem--nowrap">
        <span>{{ `${formatNumber(item?.montantHt, { decimal: 2, separateur: true })} €` }}</span>
      </div>
      <div class="elem elem--span-3 elem--nowrap">
        <span>{{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}</span>
      </div>
      <div class="elem elem--span-7">
        <BasicTooltip :label="StatutFactureLibelle[itemStatut]">
          <BasicBadge
            :type="StatutFactureBadgeType[itemStatut]"
            size="medium"
            :deletable="false"
            :label="StatutFactureLibelle[itemStatut]"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1 elem--clickable">
        <BasicTooltip label="Consulter la facture">
          <BasicIcon
            @click="useRechercheFactureActions().displayFacture(item.code)"
            name="eye"
            :active="false"
          />
        </BasicTooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import {
    type StatutFactureDTO,
    StatutFactureLibelle,
    StatutFactureBadgeType,
  } from '@/features/api/extranet/dto/Facture/StatutFactureDTO'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheFactureActions } from '../useRechercheFactureActions'

  const props = defineProps<{ item: FactureDTO }>()

  const itemStatut = computed<StatutFactureDTO>(() => {
    if (props.item?.statut) {
      return props.item?.statut as StatutFactureDTO
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
